import Head from 'next/head';

type Props = {
  errorMessage: string;
};

const ErrorSection = ({ errorMessage }: Props) => {
  return (
    <>
      <Head>
        <title>Review Widget</title>
      </Head>
      <div className="v2-widget-summary">
        <p style={{ margin: 0, lineHeight: 1.35, fontSize: '16px' }}>{errorMessage}</p>
      </div>
    </>
  );
};

export default ErrorSection;
